import React, { Component, Fragment } from "react";
import { Menu, Icon } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { Icons, Menus, MenusRoute, LocalStorage } from "constants/AppConstants";
import IconComponent from "../IconComponent";
import { setCostumeLeftActiveTab, setMakeupLeftActiveTab } from "store/action";

import "./MenuNavigations.css";

const { SubMenu } = Menu;

class MenuNavigations extends Component {
  onSelectMenu = ({ key }) => {
    const { onSelectMenu } = this.props;
    onSelectMenu(key);
    this.resetAllActiveLeftTabs();
  };

  resetAllActiveLeftTabs = () => {
    const { setCostumeLeftActiveTab, setMakeupLeftActiveTab } = this.props;
    setCostumeLeftActiveTab();
    setMakeupLeftActiveTab();
  };

  renderSubMenus(subMenus) {
    let subMenuTemplate = [];
    let menuName = "";
    let iconName = "";
    subMenus.map((subMenu, i) => {
      switch (subMenu.menuName) {
        case Menus.CAST:
          menuName = Menus.CAST;
          iconName = Icons.APPROVALS;
          break;
        case Menus.HERO_AUDITION:
          menuName = Menus.HERO_AUDITION;
          iconName = Icons.HERO_AUDITION;
          break;
        case Menus.HEROINE_AUDITION:
          menuName = Menus.HEROINE_AUDITION;
          iconName = Icons.HEROINE_AUDITION;
          break;
        default:
          break;
      }
      subMenuTemplate.push(
        <Menu.Item key={menuName}>
          <Icon type={iconName} />
          <span>
            <div>{menuName}</div>
          </span>
        </Menu.Item>
      );
      return true;
    });
    return subMenuTemplate;
  }

  renderMenus = (MenuData) => {
    let menuItemTemplate = [];
    let menuName = "";
    let iconName = "";
    let menuURL = "/";
    MenuData.map((menu) => {
      switch (menu.name) {
        case Menus.DASHBOARD:
          menuName = Menus.DASHBOARD;
          iconName = Icons.DASHBOARD;
          menuURL = `${MenusRoute.DASHBOARD}${JSON.parse(
            localStorage.getItem(LocalStorage.ACTIVE_PROJECT_ID)
          )}`;
          break;
        case Menus.COLLECTION:
          menuName = Menus.COLLECTION;
          iconName = Icons.COLLECTION;
          break;
        case Menus.ACTORS:
          menuName = Menus.ACTORS;
          iconName = Icons.ACTORS;
          menuURL = MenusRoute.ACTORS;
          break;
        case Menus.ART_SET:
          menuName = Menus.ART_SET;
          iconName = Icons.ART_SET;
          menuURL = MenusRoute.ART_SET;
          break;
        case Menus.COSTUMES:
          menuName = Menus.COSTUMES;
          iconName = Icons.COSTUMES;
          menuURL = MenusRoute.COSTUMES;
          break;
        case Menus.SCRIPTS_BREAKDOWN:
          menuName = Menus.SCRIPTS_BREAKDOWN;
          iconName = Icons.SCRIPTS_BREAKDOWN;
          menuURL = MenusRoute.SCRIPTS_BREAKDOWN;
          break;
        case Menus.LOCATION:
          menuName = Menus.LOCATION;
          iconName = Icons.LOCATION;
          menuURL = MenusRoute.LOCATION;
          break;
        case Menus.MAKEUP:
          menuName = Menus.MAKEUP;
          iconName = Icons.MAKEUP;
          menuURL = MenusRoute.MAKEUP;
          break;
        case Menus.VFX:
          menuName = Menus.VFX;
          iconName = Icons.VFX;
          menuURL = MenusRoute.VFX;
          break;
        case Menus.SONG:
          menuName = Menus.SONG;
          iconName = Icons.SONG;
          menuURL = MenusRoute.SONG;
          break;
        case Menus.STUNT:
          menuName = Menus.STUNT;
          iconName = Icons.STUNT;
          menuURL = MenusRoute.STUNT;
          break;
        case Menus.SCENE_OVERVIEW:
          menuName = Menus.SCENE_OVERVIEW;
          iconName = Icons.SCENE_OVERVIEW;
          break;
        case Menus.CREW:
          menuName = Menus.CREW;
          iconName = Icons.CREW;
          menuURL = MenusRoute.CREW;
          break;
        case Menus.CGI:
          menuName = Menus.CGI;
          iconName = Icons.CGI;
          menuURL = MenusRoute.VFX;
          break;
        case Menus.EQUIPMENTS:
          menuName = Menus.EQUIPMENTS;
          iconName = Icons.EQUIPMENTS;
          menuURL = MenusRoute.EQUIPMENTS;
          break;
        case Menus.PROJECTS:
          menuName = Menus.PROJECTS;
          iconName = Icons.PROJECTS;
          menuURL = MenusRoute.PROJECTS;
          break;
        case Menus.APPROVALS:
          menuName = Menus.APPROVALS;
          iconName = Icons.APPROVALS;
          menuURL = MenusRoute.APPROVALS;
          break;
        case Menus.SCHEDULAR:
          menuName = Menus.SCHEDULAR;
          iconName = Icons.SCHEDULAR;
          menuURL = MenusRoute.SCHEDULAR;
          break;
        case Menus.BUDJETER:
          menuName = Menus.BUDJETER;
          iconName = Icons.BUDJETER;
          menuURL = MenusRoute.BUDJETER;
          break;
        case Menus.ACCOUNTING:
          menuName = Menus.ACCOUNTING;
          iconName = Icons.ACCOUNTING;
          menuURL = MenusRoute.ACCOUNTING;
          break;
        case Menus.TRANSPORT:
          menuName = Menus.TRANSPORT;
          iconName = Icons.TRANSPORT;
          menuURL = MenusRoute.TRANSPORT;
          break;
        case Menus.INVOICE:
          menuName = Menus.INVOICE;
          iconName = Icons.INVOICE;
          menuURL = MenusRoute.INVOICE;
          break;
        case Menus.REPORT:
          menuName = Menus.REPORT;
          iconName = Icons.REPORT;
          menuURL = MenusRoute.REPORT;
          break;
        case Menus.LEGAL:
          menuName = Menus.LEGAL;
          iconName = Icons.REPORT;
          menuURL = MenusRoute.LEGAL;
          break;
        default:
          menuName = "Back to Projects";
        // iconName = Icons.COLLECTION;
      }
      if (menu.subMenus) {
        menuItemTemplate.push(
          <SubMenu
            key={menu.menuName}
            title={
              <span>
                <Icon type="mail" />
                {menu.menuName}
              </span>
            }
          >
            <Menu.ItemGroup>
              {this.renderSubMenus(menu.subMenus)}
            </Menu.ItemGroup>
          </SubMenu>
        );
      } else {
        menuItemTemplate.push(
          <Menu.Item key={menuName}>
            <Icon className="slider_icon">
              <IconComponent name={iconName} />
            </Icon>
            <span className="slider_name">
              <div>{menuName}</div>
            </span>
            <Link to={menuURL} />
          </Menu.Item>
        );
      }
      return true;
    });
    return menuItemTemplate;
  };

  render() {
    const { MenuData, defaultSelectedKeys } = this.props;
    return (
      <Fragment>
        <Menu
          onSelect={this.onSelectMenu}
          mode="vertical"
          theme="light"
          defaultSelectedKeys={[defaultSelectedKeys]}
        >
          {this.renderMenus(MenuData)}
        </Menu>
      </Fragment>
    );
  }
}

MenuNavigations.propTypes = {
  onSelectMenu: PropTypes.func.isRequired,
};

const mapStateToProps = ({ user }) => {
  return {
    currentUser: user.currentUser,
    accessToken: user.accessToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCostumeLeftActiveTab: () => dispatch(setCostumeLeftActiveTab("1")),
    setMakeupLeftActiveTab: () => dispatch(setMakeupLeftActiveTab("1")),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuNavigations);
